import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-314cea66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = { class: "title text-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "submit-wrapper" }

import { reactive } from 'vue';
  import { FormItem } from '@/types/form';
  import { authStore, userSurveysStore } from '@/stores';
  import { useI18n } from 'vue-i18n';
  import { ColorVariants } from '@/constants';
  import { useToast } from 'bootstrap-vue-3';
  import { loginGoBack } from '@/utils';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t, locale } = useI18n();
  const toast = useToast();

  const form = reactive({
    email: '',
    password: '',
  });

  const formConfigs: FormItem[] = [
    {
      label: t('EMAIL ADDRESS'),
      type: 'input',
      inputType: 'email',
      required: true,
      key: 'email',
    },
    {
      label: t('PASSWORD'),
      type: 'input',
      inputType: 'password',
      required: true,
      triggerPwd: true,
      key: 'password',
    },
  ];

  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  async function handleSubmit() {
    await authStore.loginPassword(form);
    toast.show({ title: t('Success'), body: t('Login success!') }, { variant: ColorVariants.success });
    await loginGoBack();
    // 检查登录完成之后有没有问卷
    userSurveysStore.clearHistory();
    userSurveysStore.tryPopup('after_login');
    // 更新用户信息
    authStore.fetchData();
  }

return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Sign In')), 1),
    _createVNode(_component_b_form, {
      class: "form-box",
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(formConfigs, (item) => {
          return _createVNode(_component_AppFormGroupItem, {
            key: item.key,
            form: _unref(form),
            config: item,
            onChange: formItemChange
          }, null, 8, ["form", "config"])
        }), 64)),
        _createVNode(_component_router_link, {
          class: "forget-password",
          to: {name: 'forgetPassword'}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('Forgot your password?')), 1)
          ]),
          _: 1
        }),
        (_unref(locale) !== 'ja')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                class: "forget-password",
                to: {name: 'find_id'}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Forgot your ID?')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_b_button, {
            pill: "",
            variant: "primary",
            size: "lg",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Sign In')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})